import { FlowmapParser, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { err, ok, Result } from 'neverthrow'

export interface FlowmapRendererInfo {
	rendererNumber: number|null  // null = use the built-in renderer
	minimumBundle: number|null
}

// the branch's live renderer info, which /api/v2/form/flowmap/{branchGuid}
// stamps onto the root <XFlow /> tag only when asked with ?branchInfo=1
// (branch preview); kept out of backcompat because it is never part of a
// stored flowmap
export const rendererInfoFromFlowmapParser = (parser: FlowmapParser): Result<FlowmapRendererInfo, FusionError> => {
	const info: FlowmapRendererInfo = {
		rendererNumber: null,
		minimumBundle: null,
	}
	for(const k of ['rendererNumber', 'minimumBundle'] as const) {
		const v = parser.rootNode.getAttribute(k)
		if(v) {
			const n = parseInt(v, 10)
			if(isNaN(n)) {
				return err(serializeFusionError('rendererInfoFromFlowmapParser', `invalid ${k} '${v}'`))
			}
			info[k] = n
		}
	}
	return ok(info)
}
